// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3E6jS","content":"RecentSearches_content__V2Afu"};